import { render, staticRenderFns } from "./TeamOnboardSection.vue?vue&type=template&id=1148e6c0&scoped=true"
import script from "./TeamOnboardSection.vue?vue&type=script&lang=js"
export * from "./TeamOnboardSection.vue?vue&type=script&lang=js"
import style0 from "./TeamOnboardSection.vue?vue&type=style&index=0&id=1148e6c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1148e6c0",
  null
  
)

export default component.exports